import { AppleOutlined, HistoryOutlined, DollarOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';
import DisabledCompanies from './UnpaidCompaniesTabs/DisabledCompanies';
import Expires from './UnpaidCompaniesTabs/Expires';
import RecentSubscription from './UnpaidCompaniesTabs/RecentSubscription';
import { useTagQuerySync } from '../../../../../Utils/useTagQuerySync';
import useRouteQuery from '../../../../../Utils/useRouterQuery';
import { useTabQueryGroup } from '../../../../../Utils/useTabQueryGroup';
import { EProjectNames, useProjectData } from '../../../../../Hooks/useProjectData';

const UnpaidCompany = () => {
  const { projectData } = useProjectData();
  const [tabKey, setTabKey] = useRouteQuery('1', 'tabKey', (v) => String(v));
  const unpaidTabTitle =
    projectData?.projectName === EProjectNames.RTE ? 'Unpaid Invoices' : 'Unpaid Companies';

  const dc = useTabQueryGroup('dc'); // DisabledCompanies
  const ex = useTabQueryGroup('ex'); // Expires
  const rs = useTabQueryGroup('rs'); // RecentSubscription

  useTagQuerySync(
    { en_US: unpaidTabTitle, zh_CN: '' },
    'unpaid-companies',
    {
      tabKey,
      dc_companyName: dc.companyName,
      dc_usdot: dc.usdot,
      dc_uid: dc.uid,
      dc_skip: dc.skip,
      ex_companyName: ex.companyName,
      ex_usdot: ex.usdot,
      ex_uid: ex.uid,
      ex_skip: ex.skip,
      rs_name: rs.name,
      rs_usdot: rs.usdot,
      rs_uid: rs.uid,
      rs_skip: rs.skip,
    },
    {
      tabKey: setTabKey,
      dc_companyName: dc.setCompanyName,
      dc_usdot: dc.setUsdot,
      dc_uid: dc.setUid,
      dc_skip: dc.setSkip,
      ex_companyName: ex.setCompanyName,
      ex_usdot: ex.setUsdot,
      ex_uid: ex.setUid,
      ex_skip: ex.setSkip,
      rs_name: rs.setName,
      rs_usdot: rs.setUsdot,
      rs_uid: rs.setUid,
      rs_skip: rs.setSkip,
    },
  );

  const items = [
    {
      label: <span>Subscription Expired</span>,
      key: '1',
      children: (
        <DisabledCompanies
          companyName={dc.companyName}
          setCompanyName={dc.setCompanyName}
          usdotId={dc.usdot}
          setUsdotId={dc.setUsdot}
          uid={dc.uid}
          setUid={dc.setUid}
          skip={dc.skip}
          setSkip={dc.setSkip}
        />
      ),
      icon: <AppleOutlined rev={undefined} />,
    },
    // {
    //   label: <span>Subscription Expires soon</span>,
    //   key: '2',
    //   children: (
    //     <Expires
    //       companyName={ex.companyName}
    //       setCompanyName={ex.setCompanyName}
    //       usdot={ex.usdot}
    //       setUsdot={ex.setUsdot}
    //       uid={ex.uid}
    //       setUid={ex.setUid}
    //       skip={ex.skip}
    //       setSkip={ex.setSkip}
    //     />
    //   ),
    //   icon: <HistoryOutlined rev={undefined} />,
    // },
    // {
    //   label: <span>Recent Subscription</span>,
    //   key: '3',
    //   children: (
    //     <RecentSubscription
    //       name={rs.name}
    //       setName={rs.setName}
    //       usdot={rs.usdot}
    //       setUsdot={rs.setUsdot}
    //       uid={rs.uid}
    //       setUid={rs.setUid}
    //       skip={rs.skip}
    //       setSkip={rs.setSkip}
    //     />
    //   ),
    //   icon: <DollarOutlined rev={undefined} />,
    // },
  ];

  const handleTabChange = (key: string) => {
    setTabKey(key);
  };

  return (
    <div className="mainPage">
      <Tabs activeKey={tabKey} onChange={handleTabChange} items={items} />
    </div>
  );
};

export default UnpaidCompany;
